import { cardAnatomy as cardParts } from "@chakra-ui/anatomy";
import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps, createMultiStyleConfigHelpers } from "@chakra-ui/react";

const cardHelpers = createMultiStyleConfigHelpers(cardParts.keys);
const Card = cardHelpers.defineMultiStyleConfig({
  baseStyle: (props: StyleFunctionProps) => ({
    container: {
      bg: mode("white", "base.500")(props)
    }
  })
});

export default Card;
